import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { AuthGuard, AuthModule } from '@auth0/auth0-angular'
import {
  AuthConfigStorage,
  authInitializer,
  CiamAngularModule,
} from '@cwan/ciam-angular'
import { environment } from 'environments/environment'
import { AuthTokenService } from './auth-token.service'
import { AuthTokenInterceptor } from './interceptors/auth-token.interceptor'
import { UnauthorizedRequestInterceptor } from './interceptors/unauthorized-request.interceptor'

/**
 * Angular module which provides all authentication infrastructure to Helios.
 */
@NgModule({
  imports: [
    CommonModule,
    AuthModule.forRoot(environment.auth0),
    CiamAngularModule,
  ],
  providers: [
    AuthTokenService,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedRequestInterceptor,
      multi: true,
    },
    {
      // Setup authInitializer to complete Auth0 initialization
      provide: APP_INITIALIZER,
      useFactory: authInitializer,
      deps: [AuthConfigStorage],
      multi: true,
    },
  ],
})
export class HeliosAuthModule {
  constructor(private readonly authTokenService: AuthTokenService) {}
}
